<template>
  <el-row class="add-news">
    <el-col :span="12">
      <strong>{{ id ? "Tovarni tahrirlash" : `Tovar qo'shish` }}</strong>
    </el-col>

    <el-col :span="24" style="margin-top: 10px">
      <el-form label-position="top" ref="formRef" :model="productModel">
        <el-form-item label="Doskani tanlang"
                      prop="board_id"
                      :rules="[{required: true, message: 'Majburiy maydon', trigger: 'change'}]"
        >
          <el-select size="large" v-model="productModel.board_id" style="width: 100%">
            <el-option
                v-for="board in boards"
                :key="board.id"
                :value="board.id"
                :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
            />
          </el-select>
        </el-form-item>
        <el-tabs v-model="activeName">
          <el-tab-pane label="UZB" name="uz">
            <el-form-item
                label="Sarlavha"
                prop="title.uz_lat"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Uz)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (Uz)"
                  v-model="productModel.title.uz_lat"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="UZB Krill" name="uz_cyr">
            <el-form-item
                label="Sarlavha"
                prop="title.uz_cyr"
                :rules="[{ required: true, message: 'Sarlavha majburiy (UzKr)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (UzKr)"
                  v-model="productModel.title.uz_cyr"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="RU" name="ru">
            <el-form-item
                label="Sarlavha"
                prop="title.ru"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Ru)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (Ru)"
                  v-model.number="productModel.title.ru"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="ENG" name="en">
            <el-form-item
                label="Sarlavha (En)"
                prop="title.en"
                :rules="[{ required: true, message: 'Sarlavha majburiy (En)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (En)"
                  v-model.number="productModel.title.en"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="KP" name="kp">
            <el-form-item
                label="Sarlavha (Kp)"
                prop="title.kr"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Kp)' }]"
            >
              <el-input
                  placeholder="Sarlavhani kiriting (Kp)"
                  v-model.number="productModel.title.kr"
                  type="text"
                  autocomplete="off"
              />
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
        <el-form-item
            label="Kategoriya"
            prop="category_id"
            :rules="[{ required: true, message: 'Kategoriya tanlash majburiy' }]"
        >
          <el-select
              v-model="productModel.category_id"
              placeholder="Kategoriya"
              style="width: 100%"
          >
            <el-option
                v-for="category in categories"
                :value="category.id"
                :key="category.id"
                :label="category.title"
            />
          </el-select>
        </el-form-item>
        <el-form-item
            label="O'lchov birligi"
            prop="unit_of_measure"
            :rules="[
            { required: true, message: 'O\'lchov birligini tanlash majburiy' },
          ]"
        >
          <el-select
              v-model="productModel.unit_of_measure"
              placeholder="O'lchov birligi"
              style="width: 100%"
          >
            <el-option
                v-for="unit in units"
                :value="unit.value"
                :key="unit.name"
                :label="unit.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item
            label="Tovar soni"
            prop="max_available"
            :rules="[
            { required: true, message: 'Tovar sonini kiritish majburiy' },
          ]"
        >
          <el-input
              placeholder="Tovar sonini kiriting"
              v-model="productModel.max_available"
              type="number"
              autocomplete="off"
          />
        </el-form-item>
        <el-form-item
            label="Narx"
            prop="price"
            :rules="[
            { required: true, message: 'Narxni kiritish majburiy' },
          ]"
        >
          <el-input
              placeholder="Narxni kiriting"
              v-model="productModel.price"
              type="number"
              autocomplete="off"
          />
        </el-form-item>

        <div class="mt-15 text-right">
          <router-link
              to="/app/products/list"
              class="el-button el-button--danger"
          >
            Bekor qilish
          </router-link>
          <el-button type="primary" @click="submitForm(formRef)"
          >Saqlash
          </el-button
          >
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage} from "element-plus";
import http from "@/http";
import router from "@/router";
import {useRoute} from "vue-router";


const formRef = ref();
const loading = ref(false);
const categories = ref([]);
const units = ref([{value: "collection", name: "To'plam"}, {value: "piece", name: "Dona"}]);
const activeName = ref("uz");
const boards = ref([]);

const route = useRoute();
const {id} = route.params;
let productModel = reactive({
  title: {
    uz_lat: "",
    uz_cyr: "",
    ru: "",
    en: "",
    kr: "",
  },
  category_id: "",
  unit_of_measure: "",
  max_available: null,
  price: null,
  board_id: null
});

const submitForm = async (formEl) => {
  productModel.max_available = parseInt(productModel.max_available)
  productModel.price = parseInt(productModel.price)
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      loading.value = true;
      http({
        url: `api/v1/products${id ? `/${id}` : ""}`,
        data: productModel,
        method: id ? "put" : "post",
        headers: {},
      })
          .then(() => {
            router.push("/app/products/list");
          })
          .catch((err) => {
            console.log(err);
            ElMessage.error(`Xatolik qayta urinib ko'ring`);
          })
          .finally(() => {
            loading.value = false;
          });
    } else {
      const errors = [];
      for (const keys in fields) {
        fields[keys].map((item) => {
          errors.push(item);
        });
      }
      errors.map((error) => {
        ElMessage.error(error.message);
      });
      console.log("error submit!", fields);
    }
  });
};

const getBoards = () => {
  loading.value = true;
  http({url: `api/v1/boards`, params: {status: 1}})
      .then(({data}) => {
        boards.value = data.boards;
      })
      .catch((err) => {
        ElMessage.error(
            err.response.data.message || `Hatolik qayta urinib ko'ring`
        );
      })
      .finally(() => {
        loading.value = false;
      });
};

onMounted(() => {
  if (id) {
    http.get(`api/v1/products/${id}`).then((res) => {
      Object.assign(productModel, res.data);
    });
  }

  http.get("api/v1/product-categories").then((res) => {
    categories.value = res.data.product_categories;
  });
  getBoards()
});
</script>

<style>
.file-upload label {
  margin: 0 !important;
}

.add-news .el-input__wrapper {
  padding: 0 1rem !important;
}

.input-hidden .el-form-item__content {
  height: 0;
  padding: 0;
}
</style>
<style scoped lang="scss">
.linkButtons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  width: 450px;

  button {
    width: 100%;
  }
}

.file-upload-button {
  padding: 1rem;
  border: 1px dotted #e1e1e1;
  border-radius: 8px;
  overflow: hidden;
  color: #808080;
  display: block;
  max-width: 240px;
  cursor: pointer;

  &:hover {
    background-color: #e1e1e1;
  }

  img {
    max-width: 100%;
    object-fit: cover;
  }
}

.text-right {
  text-align: right;
}

a {
  text-decoration: none;
}

.form-row {
  display: flex;
  gap: 15px;
}
</style>
